import { useEffect, useRef, useState } from "react";
import styles from "./style.module.scss";

import bmg from "../../images/empresas/bmg.webp";
import nova from "../../images/empresas/nova.png";
import prix from "../../images/empresas/prix.png";
import revelo from "../../images/empresas/revelo.svg";
import santander from "../../images/empresas/santander.webp";
import suzano from "../../images/empresas/suzano.png";

export const CarrosselLogosConsultoria = ({className}) => {
  const empresas = [bmg, nova, prix, revelo, santander, suzano];
  const logosSlideRef = useRef(null);
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const animationIntervalRef = useRef(null);

  useEffect(() => {
    const logosSlide = logosSlideRef.current;

    // Verificação se o logosSlide é um elemento válido
    if (logosSlide) {
      const checkWrapCondition = () => {
        const isWrapped = logosSlide.scrollWidth > logosSlide.clientWidth;
        setShouldAnimate(isWrapped);
      };

      const resizeObserver = new ResizeObserver(() => {
        checkWrapCondition();
      });

      resizeObserver.observe(logosSlide);

      // Limpar o observador quando o componente desmontar
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  useEffect(() => {
    const logosSlide = logosSlideRef.current;

    if (shouldAnimate && logosSlide) {
      const handleAnimation = () => {
        logosSlide.scrollLeft += 1;

        if (logosSlide.scrollLeft >= logosSlide.scrollWidth / 2) {
          logosSlide.scrollLeft = 0;
        }
      };

      animationIntervalRef.current = setInterval(handleAnimation, 30);

      return () => {
        clearInterval(animationIntervalRef.current);
      };
    } else if (logosSlide) {
      clearInterval(animationIntervalRef.current);
    }
  }, [shouldAnimate]);

  return (
    <section className={styles.carrosselWrapper}>
      <div className={`${styles.carrossel} ${className} fadeBottomSlow`} >
        <div className={styles.logosContainer} ref={logosSlideRef}>
          {shouldAnimate
            ? empresas
                .concat(empresas)
                .map((logoSrc, index) => (
                  <img
                    key={index}
                    src={logoSrc}
                    alt={`Logo da empresa ${index}`}
                    className={styles.logo}
                  />
                ))
            : empresas.map((logoSrc, index) => (
                <img
                  key={index}
                  src={logoSrc}
                  alt={`Logo da empresa ${index}`}
                  className={styles.logo}
                />
              ))}
        </div>
      </div>
    </section>
  );
};
